import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "text-[16px] text-[#fff] text-justify leading-6 content"
};
const _hoisted_2 = {
    key: 0
};
import { ElTooltip } from 'element-plus';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'CustomTooltip',
        inheritAttrs: false
    },
    __name: 'CustomTooltip',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        placement: {
            default: 'top'
        },
        content: {},
        trigger: {
            default: 'hover'
        },
        showAfter: {
            default: 0
        },
        hideAfter: {
            default: 200
        },
        popperClass: {},
        closeOnClick: {
            type: Boolean,
            default: true
        }
    },
    setup (__props) {
        const props = __props;
        // 将 props 传递给 ElTooltip 组件
        const tooltipProps = computed(()=>{
            const { content, ...rest } = props;
            return rest;
        });
        return (_ctx, _cache)=>{
            return _openBlock(), _createBlock(_unref(ElTooltip), _mergeProps(tooltipProps.value, {
                effect: "customized"
            }), {
                default: _withCtx(()=>[
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                content: _withCtx(()=>[
                        _createElementVNode("div", _hoisted_1, [
                            _renderSlot(_ctx.$slots, "content", {}, ()=>[
                                    props.content ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.content), 1)) : _createCommentVNode("", true)
                                ])
                        ])
                    ]),
                _: 3
            }, 16);
        };
    }
});
